import { useEffect, useState } from 'react'
import EkomApi from '../api/EkomApi'
import { createGlobals } from '../context/createGlobals'
import { useExternalSystems } from './useExternalSystems'

interface iDataToFetch {
  extObjId: string,
  extSystem: string,
}

interface iMsgCountState {
  [extSysObjId: string]: iCacheData;
}

interface iCacheData {
  loading: boolean
  error: string
  data: number
}

const BLOCK_SIZE = 10
const GLOBAL_STATE_ATTR = 'items'
const initState = { [GLOBAL_STATE_ATTR]: {} as iMsgCountState }
const { useGlobalState } = createGlobals(initState)

const TO_FETCH: iDataToFetch[] = []
let FETCHED: iDataToFetch[] = []

export const useMsgsCountAdd = () => {

  const addToFetch = (dataTo: iDataToFetch[]) => {

    dataTo
      .filter(dT => dT.extObjId && dT.extSystem && !TO_FETCH.some(dO => dT.extObjId === dO.extObjId && dT.extSystem === dO.extSystem))
      .forEach((d) => {
        TO_FETCH.push(d)
      })
  }

  const clearMsgCounter = (extSystem: string, extId: string) => {
    FETCHED = FETCHED.filter(f => f.extSystem !== extSystem || f.extObjId !== extId)
  }

  return { addToFetch, clearMsgCounter }
}

export const useMsgsCounts = (extSystem: string, extId: string) => {

  const [readyToFetch, setReadyToFetch] = useState(false)
  const [state, setState] = useGlobalState(GLOBAL_STATE_ATTR)
  const actItem = state[extSystem + extId]
  const actItemData = actItem?.data || 0

  const { data: extSystemWithEkom } = useExternalSystems()

  const fetchGroup = async () => {

    const noFetched = TO_FETCH.filter(a => extSystemWithEkom.includes(a.extSystem) && !FETCHED.some(b => a.extObjId === b.extObjId && a.extSystem === b.extSystem))

    const thisIndex = noFetched.findIndex(a => a.extObjId === extId && a.extSystem === extSystem)
    if (thisIndex === -1) {
      return
    }
    const start = Math.floor(thisIndex / 10) * 10
    const nowFetch = noFetched.slice(start, start + BLOCK_SIZE)
    nowFetch.forEach(a => {
      FETCHED.push(a)
    })

    const extSystemObjIds = nowFetch.map(d => ({
      systemExtId: d.extSystem,
      objectExtId: d.extObjId
    }))

    extSystemObjIds.forEach((o) => {
      const id = o.systemExtId + o.objectExtId
      state[id] = {
        error: '',
        data: 0,
        loading: false
      }
    })

    setState({ ...state })

    try {
      const resultIn = await EkomApi.searchMsgsReadIncoming(extSystemObjIds)
      resultIn.map((res) => {
        const id = res.systemExtId + res.objectExtId
        state[id].data = res.unreadMessagesCount
      })

      const resultOut = await EkomApi.searchMsgsReadOutgoing(extSystemObjIds)
      resultOut.map((res) => {
        const id = res.systemExtId + res.objectExtId
        state[id].data += res.unreadMessagesCount
      })
      extSystemObjIds.forEach((o) => {
        const id = o.systemExtId + o.objectExtId
        state[id].loading = false
      })
      setState({ ...state })
    } catch (error: any) {
      extSystemObjIds.forEach((o) => {
        const id = o.systemExtId + o.objectExtId
        state[id].error = error.toString()
        state[id].loading = false
      })
      setState({ ...state })
    }
  }

  useEffect(() => {
    if (readyToFetch && extSystemWithEkom && extSystemWithEkom.length) {
      fetchGroup()
    }
  }, [readyToFetch, extSystemWithEkom])

  useEffect(() => {
    setReadyToFetch(true)
  }, [])

  return { data: actItemData }
}
